import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import Highlighter from "react-highlight-words";

export const AntTableSearchFilter = ({
  inputRef,
  resetRef,
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  dataIndex,
  setSearchText,
  setColumn,
}) => {
  const handleColumnSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    confirm({ closeDropdown: true });
    setSearchText("");
    setColumn(dataIndex);
  };
  useEffect(() => {}, [selectedKeys]);

  return (
    <div style={{ padding: 8 }}>
      <Input
        ref={inputRef}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() =>
          handleColumnSearch(selectedKeys, confirm, dataIndex)
        }
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
      <Button
        type="primary"
        onClick={() => handleColumnSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined width={5} height={5} />}
        size="small"
        style={{ width: 90, marginRight: 8, height: 30 }}
      >
        Search
      </Button>
      <Button
        ref={resetRef}
        onClick={() => handleReset(clearFilters, confirm, dataIndex)}
        size="small"
        style={{ width: 90, height: 30 }}
      >
        Reset
      </Button>
    </div>
  );
};

export const getColumnSearchProps = (
  dataIndex,
  inputRef,
  resetRef,
  searchText,
  setSearchText,
  column,
  setColumn
) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <AntTableSearchFilter
      dataIndex={dataIndex}
      inputRef={inputRef}
      resetRef={resetRef}
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
      setSearchText={setSearchText}
      setColumn={setColumn}
    />
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
  ),
  onFilter: (value, record) =>
    record[dataIndex]?.toString()?.toLowerCase()?.includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => inputRef.current.select());
    }
  },
  render: (text) =>
    column === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text?.toString()}
      />
    ) : (
      text
    ),
});
